export default "__VITE_ASSET__D_ThDPRS__ 430w";